module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app-wrapper"
    }
  }, [_c('div', {
    attrs: {
      "id": "app-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', [_c('captures')], 1), _vm._v(" "), (_vm.showJoiningDialog) ? _c('joining-game-overlay') : _vm._e(), _vm._v(" "), (_vm.showNewGamePrompt) ? _c('div', {
    staticClass: "app-prompt-overlay"
  }, [_c('div', [_c('div', {
    staticClass: "app-prompt"
  }, [(_vm.gameDone) ? _c('div', [_c('h5', [_vm._v("Game Complete!")]), _vm._v(" "), _c('ul', {
    staticClass: "app-game-scores"
  }, [_c('li', [_vm._v("Black: " + _vm._s(_vm.score[_vm.BLACK]))]), _vm._v(" "), _c('li', [_vm._v("White: " + _vm._s(_vm.score[_vm.WHITE]))])])]) : _c('div', [_c('h5', [_vm._v("Welcome to VueGo")])]), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-js-ripple-effect",
    attrs: {
      "colored": "",
      "raised": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.promptNewGame($event)
      }
    }
  }, [_vm._v("\n              New Game\n            ")])], 1)])]) : _vm._e(), _vm._v(" "), _c('board', {
    attrs: {
      "local-current-turn": _vm.localCurrentTurn,
      "ko": _vm.ko,
      "size": _vm.size,
      "board": _vm.board
    },
    on: {
      "play": _vm.play
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "app-actions"
  }, [(_vm.localCurrentTurn) ? _c('div', [_c('mdl-button', {
    staticClass: "mdl-js-ripple-effect",
    attrs: {
      "id": "pass",
      "fab": "",
      "icon": "",
      "colored": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.pass($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("skip_next")])]), _vm._v(" "), _c('mdl-tooltip', {
    attrs: {
      "target": "pass"
    }
  }, [_vm._v("\n        Pass Turn\n      ")])], 1) : _vm._e()]), _vm._v(" "), (_vm.showNewGameDialog) ? _c('new-game-dialog', {
    on: {
      "new-game": _vm.doNewGame,
      "cancel": _vm.hideNewGamePrompt
    }
  }) : _vm._e(), _vm._v(" "), (_vm.waitingForRemoteOpponent) ? _c('invite-opponent-dialog', {
    on: {
      "cancel": _vm.cancelRemoteGame
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1554b617"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 415
// module chunks = 1